<template>
  <div class='sub-content'>
    <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid
        ref='refPlanInfoGrid'
        :data-source='planInfoList'
        :show-borders='true'
        :showRowLines='false'
        :showColumnLines='true'
        :hover-state-enabled='true'
        :allowColumnResizing='true'
        column-resizing-mode='widget'
        :allow-column-reordering='true'
        :height='gridHeight'
        :row-alternation-enabled='true'
        :focused-row-enabled='true'
        :auto-navigate-to-focused-row='false'
        @row-updating="onRowUpdatingPlan"
        @row-updated='onRowUpdatedPlan'
        @toolbar-preparing='onToolbarPreparing'
        @cell-prepared='onCellPrepared'
        key-expr='품번'
      >
        <DxSearchPanel :visible='true' placeholder='검색...' />
        <DxExport :enabled='true' file-name='다공정주간계획' />
        <DxFilterRow :visible='true' apply-filter='auto' />
        <DxKeyboardNavigation
          :edit-on-key-press='true'
          enter-key-action='moveFocus'
          enter-key-direction='row'
        />
        <DxEditing
          :allow-deleting='false'
          :allow-updating='true'
          :allow-adding='false'
          :use-icons='true'
          :mode='!isEdiotable ? "cell" : "batch"'
        >
        </DxEditing>
        <DxColumnFixing :enabled='true' />
        <DxColumn
          v-if='$store.getters.getGroupName !== null'
          :caption='$store.getters.getGroupName'
          data-field='차종'
          :allowEditing='false'
          width='70'
        >
        </DxColumn>
        <DxColumn caption='품번' data-field='품번' width='120' :allowEditing='false'> </DxColumn>
        <DxColumn caption='품명' data-field='품명' width='150' :allowEditing='false'> </DxColumn>
        <!-- <DxColumn
          caption='라인명'
          data-field='라인코드'
          :minWidth='70'
          :allowEditing='false'
        >
          <DxLookup
            :data-source='lineLookup'
            display-expr='라인명'
            value-expr='라인코드'
          />
        </DxColumn> -->
        <!-- <DxColumn caption='공정유형' data-field='공정유형' width='80' :allowEditing='false'>
          <DxLookup
            :data-source='processingTypeLookup'
            display-expr='코드명'
            value-expr='코드'
          />
        </DxColumn> -->
        <!-- <DxColumn :allowEditing='false' dataType='number' caption='UPH' data-field='uph' :min-width='70'> </DxColumn> -->
        <DxColumn :allowEditing='!isEdiotable' dataType='number' caption='생산로트' data-field='생산로트수량' :min-width='70'> </DxColumn>
        <DxColumn :allowEditing='false' dataType='number' caption='계획수량' data-field='월합계' :min-width='70'> </DxColumn>
        <DxColumn :allowEditing='false' dataType='number' caption='현재고' data-field='현재공' :min-width='70'> </DxColumn>
        <DxColumn :allowEditing='false' dataType='number' caption='일출하수량' data-field='일출하수량' :min-width='70'> </DxColumn>
        <DxColumn :allowEditing='false' dataType='number' caption='사용일수' data-field='사용일수' :min-width='70'> </DxColumn>
        <DxColumn :allowEditing='!isEdiotable' caption='저장여부' data-field='저장여부' :min-width='70'> </DxColumn>
        <DxColumn :allowEditing='false' caption='부족수량' data-field='필요수량' :min-width='70'> </DxColumn>
        <DxColumn
          format='#,##0'
          caption='합계'
          dataType='number'
          :calculateCellValue='sumPlanQty'
          :min-width='70'
          :allowEditing='false'
        >
        </DxColumn>
        <DxColumn caption='생산계획' alignment='center'>
          <DxColumn
            v-for='(item, index) in dateArray'
            :key='index'
            :caption='item.caption'
            :data-field='item.dataField'
            :allowEditing='isEdiotable'
            :data-type='item.dataType'
            :format='item.format'
            :allow-sorting='false'
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column='합계'
            summary-type='sum'
            display-format='{0}'
          />
          <DxTotalItem
            v-for='(item, index) in dateArray'
            :key='index + 100'
            value-format='#,##0'
            :column='item.dataField'
            summary-type='sum'
            display-format='{0}'
          />
        </DxSummary>
        <dx-paging :enabled='false' />
        <dx-scrolling
          mode='virtual'
          showScrollbar='always'
          :useNative='false'
        />
        <dx-sorting mode='multiple' />
        <template #lineSelect>
          <div class="toolbar-label template-div">
            <DxSelectBox
              :data-source="lineLookup"
              :value="selectedLine"
              display-expr="라인명"
              value-expr="라인코드"
              @value-changed="onLineValueChanged"
            />
          </div>
        </template>
        <template #operate-day-template>
          <div class="toolbar-label template-div">
            <b>조업일수 : {{ workDay }}</b>
            <b> &nbsp;일최대생산수량 : {{ mdpq }}</b>
          </div>
        </template>
        <template #reset-template>
          <div class="toolbar-label template-div">
            <!-- <b>조업일수 : {{ workDay }}</b> -->
            <DxButton v-if="isEdiotable" type="danger" text="초기화" @click="resetPlan"></DxButton>
            <DxButton v-else type="success" text="저장" @click="savePlan"></DxButton>
          </div>
        </template>
      </dx-data-grid>
      <loading
        :active.sync='isLoading'
        color='rgb(2, 110, 156)'
        loader='bars'
      ></loading>
    </div>
  <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, {
  DxScrolling,
  DxFilterRow,
  DxExport,
  DxColumnFixing,
  DxTotalItem,
  DxSummary,
  DxKeyboardNavigation,
  DxColumn,
  DxPaging,
  DxSorting,
  DxEditing,
  DxSearchPanel
  // DxLookup
} from 'devextreme-vue/data-grid'
import DxSelectBox from 'devextreme-vue/select-box'
import { DxButton } from 'devextreme-vue'

export default {
  name: 'productionDailyPlan',
  data: function () {
    return {
      isLoading: false,
      gridHeight: null,
      selectedDate: null,
      dateArray: [],
      planInfoList: [],
      orginPlanInfoList: [],
      processingTypeLookup: null, // 공정유형
      lineLookup: [], // 생산라인
      selectedLine: null,
      productypeLookup: null,
      restDays: [],
      workDay: null,
      isEdiotable: false,
      mdpq: null // 일최대생산수량
    }
  },
  props: {
    isPlanning: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxSearchPanel,
    // DxLookup,
    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxKeyboardNavigation,
    DxSelectBox,
    DxButton
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.selectedDate = AppLib.calcMonthFromToday(1).substring(0, 7) // 다음달 가져옴
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
  },
  async mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
    await this.initDateArray()
    await this.refreshLine()
  },
  updated () {},
  beforeDestroy: function () {},
  computed: {},
  methods: {
    onCellPrepared (e) {
      // 그리드 컬럼 11 부터 날짜
      // 토요일,일요일 색상 구분
      if (e.rowType === 'data' && e.columnIndex > 10) {
        const restInfo = this.$_.findWhere(this.restDays, { 휴일: e.columnIndex - 10 })
        if (restInfo !== undefined) {
          e.cellElement.style.cssText = restInfo.text === '토요일' ? 'background-color: cornflowerblue' : 'background-color: lightcoral'
        }
      } else if (e.rowType === 'data' && e.column.dataField === '사용일수') {
        if (e.data.재고여분) {
          e.cellElement.style.cssText = 'background-color: lightgreen'
        }
      } else if (e.rowType === 'data' && e.column.caption === '합계') {
        if (e.row.data.필요수량 + e.value < 0 && e.value !== 0) {
          e.cellElement.style.cssText = 'color: lightcoral'
        }
      }
    },
    refreshLine () {
      this.$_sp.runNoEncodeFindSqlProc('생산라인', { 생산계획: 1 })
        .then((data) => {
          this.lineLookup = this.$_sp.MakeModel(data)
          if (this.lineLookup.length > 0) {
            this.selectedLine = this.lineLookup[0].라인코드
            this.mdpq = this.lineLookup[0].uph * 20
          }
        })
    },
    async initDateArray () {
      this.dateArray = []
      this.restDays = []
      const lastDay = AppLib.getMonthLastDateByDate(`${this.selectedDate}-01`).substring(8, 10)
      await this.$_sp.runNoEncodeFindSqlProc('조업정보', { 계획연월: this.selectedDate })
        .then((result) => {
          const days = this.$_sp.MakeModel(result)
          console.log('조업정보')
          this.workDay = lastDay - days.length
          days.forEach(element => {
            const day = AppLib.formatDateFromTimeStamp(element.startDate).substring(8, 10)
            element.휴일 = parseInt(day)
            this.restDays.push(element)
          })
        })
      for (let j = 1; j <= lastDay; j++) {
        const restInfo = this.$_.findWhere(this.restDays, { 휴일: j })
        let restDay = {
          caption: `${j}`,
          dataField: `${j}`,
          format: '#,##0',
          dataType: 'number'

        }
        if (restInfo !== undefined) {
          restDay.allowEditing = false
        } else {
          restDay.allowEditing = true
        }
        this.dateArray.push(restDay)
      }
      console.log(this.dateArray)
    },
    refreshDailyPlan () {
      this.planInfoList = []
      this.orginPlanInfoList = []
      const param = {
        toDate: `${this.selectedDate}-01`,
        workDay: this.workDay,
        lineCode: this.selectedLine
      }
      this.$_sp.runNoEncodeFindProc('spFindAllDailyPlanByDate', param)
        .then((data) => {
          const result = this.$_sp.MakeModel(data)
          result.forEach(element => {
            if (element.생산계획 !== null) {
              const plan = (element.생산계획).replace(/'/g, '"')
              element.저장여부 = true
              Object.assign(element, JSON.parse(plan))
            } else {
              element.저장여부 = false
            }
            element.잔여수량 = element.필요수량
            element.누적생산수량 = 0
            console.log(element)
            this.orginPlanInfoList.push(Object.assign({}, element))
            this.planInfoList.push(element)
          })
          // test = [...this.planInfoList]
          const isSave = this.$_.findWhere(this.planInfoList, { 저장여부: true })

          this.isEdiotable = isSave !== undefined
          if (!this.isEdiotable) this.calcDailyPlan()
        })
    },
    async calcDailyPlan () {
      const workDays = this.dateArray.filter(item => item.allowEditing !== false)
      const noPlanList = this.planInfoList.filter(item => item.재고여분 === 0 && item.저장여부 === false)
      let 남은하루생산수량 = this.mdpq // 데일리 남은수량
      let 남은로트수량 = 0
      let 생산수량 = 0
      let j = 0
      for (let i = 0; i < workDays.length; i++) {
        if (noPlanList.length <= 0) {
          console.log('끝')
          break
        }
        const day = workDays[i].dataField
        if (noPlanList.length === j && workDays.length !== i) {
          j = 0
        }
        // if (noPlanList[j][day] !== undefined) {
        //   남은하루생산수량 = this.mdpq
        //   continue
        // }
        let itemLotQty = noPlanList[j].생산로트수량

        if (noPlanList[j].잔여수량 >= 0 && noPlanList[j].누적생산수량 % itemLotQty === 0) {
          noPlanList.splice(j, 1)
          i--
          continue
          // if(noPlanList[j].잔여수량/ )
        } else if (noPlanList[j].잔여수량 >= 0 && (itemLotQty - noPlanList[j].누적생산수량 > 0)) {
          if (남은하루생산수량 >= noPlanList[j].잔여수량) {
            남은로트수량 = itemLotQty - noPlanList[j].누적생산수량
          }
        }
        itemLotQty = noPlanList[j].생산로트수량
        생산수량 = 남은로트수량 === 0 ? itemLotQty : 남은로트수량
        // 남은로트수량 = 0
        if (생산수량 > 남은하루생산수량) {
          생산수량 = 남은하루생산수량
          남은로트수량 = (남은로트수량 === 0 ? itemLotQty : 남은로트수량) - 생산수량
          // if (남은로트수량 !== 0 && 남은로트수량 - 생산수량 > 0) {
          //   남은로트수량 = 남은로트수량 - 생산수량
          // } else {
          //   남은로트수량 = 0
          // }
        } else {
          남은로트수량 = 0
        }
        남은하루생산수량 -= 생산수량
        noPlanList[j][day] = noPlanList[j][day] !== undefined ? noPlanList[j][day] += 생산수량 : 생산수량
        noPlanList[j].잔여수량 += 생산수량
        noPlanList[j].누적생산수량 += 생산수량

        console.log(day + '일 ' + noPlanList[j].품번 + ' ' + 생산수량 + '개 생산 // ' + noPlanList[j].누적생산수량 + '개 누적 // ' + 남은로트수량 + '로트 수량 남음')
        // console.log(남은하루생산수량)
        if (남은하루생산수량 > 0) {
          i--
          j++
        } else {
          if (남은로트수량 === 0) {
            j++
          }
          남은하루생산수량 = this.mdpq
          console.log('안남음')
          console.log(남은로트수량)
          console.log(남은하루생산수량)
        }
        // if (남은하루생산수량 >= itemLotQty && 남은로트수량 <= 0) {
        //   생산수량 = itemLotQty
        // } else if (남은로트수량 > 0) {
        //   생산수량 = 남은로트수량
        //   남은로트수량 = 0
        // } else {
        //   생산수량 = 남은하루생산수량
        //   남은로트수량 = itemLotQty - 생산수량
        // }
        // 남은하루생산수량 -= 생산수량
        // noPlanList[j][day] = 생산수량
        // console.log(day + '일 ' + noPlanList[j].품번 + ' ' + 생산수량 + '개 생산')
        // if (남은하루생산수량 > 0) {
        //   console.log(남은하루생산수량 + '개 남음')
        //   i--
        //   j++
        // } else {
        //   남은하루생산수량 = this.mdpq
        //   console.log('안남음')
        //   console.log(남은로트수량)
        //   if (남은로트수량 <= 0) {
        //     j++
        //   }
        // }

        // if (남은하루생산수량 > 0) { // 아래로
        //   let isGreaterThanLotQty = false
        //   생산수량 = 남은하루생산수량 >= itemLotQty ? itemLotQty : 남은하루생산수량
        //   if (생산수량 < itemLotQty) {
        //     remainLotQty = 생산수량
        //     if (itemLotQty > this.mdpq && 남은하루생산수량 === this.mdpq) {
        //       isGreaterThanLotQty = true
        //       remainLotQty = 0
        //     }
        //   } else {
        //     생산수량 = 생산수량 - remainLotQty
        //     remainLotQty = 0
        //   }
        //   noPlanList[j][day] = 생산수량
        //   noPlanList[j].잔여수량 += 생산수량

        //   남은하루생산수량 = 남은하루생산수량 - 생산수량

        //   if (remainLotQty === 0 && noPlanList[j].잔여수량 >= 0) {
        //     // console.log(noPlanList[j]['품번'])
        //     // noPlanList[j].isFinish = true
        //     noPlanList.splice(j, 1)
        //     // console.log(noPlanList)
        //     if (noPlanList.length > 0) {
        //       j--
        //     } else {
        //       break
        //     }
        //   } else if (remainLotQty > 0) {
        //     console.log('================================')
        //     console.log(noPlanList[j]['품번'])
        //     console.log('생산수량  ->>  ' + 생산수량)
        //     console.log('잔여수량  ->>  ' + noPlanList[j].잔여수량)
        //     console.log('남은로트수량  ->>  ' + remainLotQty)
        //     console.log('남은하루수량  ->>  ' + 남은하루생산수량)
        //     console.log('================================')
        //   }
        //   if (남은하루생산수량 !== 0) {
        //     i--
        //     j++
        //   } else {
        //     남은하루생산수량 = this.mdpq
        //     if (isGreaterThanLotQty) j++
        //   }
        // }
      }
      console.log(this.planInfoList)
    },
    onRowUpdatingPlan (e) {
      // this.newData = e.newData
      console.log(e)
    },
    onRowUpdatedPlan (row) {
      console.log(row)
      if (!this.isEdiotable) {
        this.updateLotQty(row)
        return
      }
      let obj = {}
      this.dateArray.forEach(element => {
        const day = parseInt(element.dataField)
        if (row.data[day] !== undefined && row.data[day] !== null) {
          console.log(row.data[day])
          if (row.data[day] !== 0) {
            obj[day] = row.data[day]
          }
        }
      })
      const param = {
        품번: row.data.품번,
        차종: row.data.차종,
        계획연월: row.data.계획연월,
        생산계획: Object.keys(obj).length <= 0 ? null : JSON.stringify(obj).replace(/"/g, "'")
      }
      this.$_sp.runInsertOrUpdayeSqlProc('일생산계획', ['품번', '차종', '계획연월'], null, [param])
        .then(() => {
          this.$snotify.info('저장되었습니다.')
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async updateLotQty (row) {
      console.log(row)
      const param = {
        품번: row.data.품번,
        차종: row.data.차종,
        계획연월: row.data.계획연월
      }
      const rowInfo = this.$_.findWhere(this.orginPlanInfoList, param)
      rowInfo.생산로트수량 = row.data.생산로트수량
      console.log(rowInfo)
      console.log(this.orginPlanInfoList)
      this.planInfoList = this.orginPlanInfoList.map(v => Object.assign({}, v))
      // this.planInfoList = [...this.orginPlanInfoList]
      await this.calcDailyPlan()
      console.log('updateLotQty')
      this.$refs.refPlanInfoGrid.instance.refresh()
      // this.$_sp.runInsertOrUpdayeSqlProc('일생산계획', ['품번', '차종', '계획연월'], null, [param])
      //   .then(() => {
      //     this.$snotify.info('저장되었습니다.')
      //     this.refreshDailyPlan()
      //   })
      //   .catch(error => {
      //     if (error.response.status === ConstDef.GENERRAL_ERROR) {
      //       this.$snotify.error(error.response.data.message)
      //     } else {
      //       this.$snotify.error(`에러코드 : ${error.response.status}`)
      //     }
      //   })
      //   .finally(() => {
      //     this.isLoading = false
      //   })
    },
    calcSumDailyOuput (e) {
      return e.월합계 / this.workDay
    },
    consumptionDate (e) {
      return e.현재공 / (e.월합계 / this.workDay)
    },
    sumPlanQty (e) {
      let sum = 0
      for (let i = 1; i <= this.dateArray.length; i++) {
        if (typeof (e[`${i}`]) === 'number') {
          sum += e[`${i}`]
        }
      }
      return sum
    },
    onLineValueChanged (e) {
      this.selectedLine = e.value
      const lineInfo = this.$_.findWhere(this.lineLookup, { 라인코드: e.value })
      this.mdpq = lineInfo.uph * 20
      this.refreshDailyPlan()
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:rgb(4, 103, 189);'><b>기준월 :  </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.selectedDate,
            type: 'date',
            acceptCustomValue: false,
            calendarOptions: {
              maxZoomLevel: 'year',
              minZoomLevel: 'century'
            },
            max: `${AppLib.calcMonthFromToday(3).substring(0, 7)}`,
            dateSerializationFormat: 'yyyy-MM',
            displayFormat: 'yyyy-MM',
            onValueChanged: async (args) => {
              console.log(args.value)
              this.selectedDate = args.value
              await this.initDateArray()
              await this.refreshDailyPlan()
              // this.selectedDate = args.value
            }
          }
        },
        {
          location: 'before',
          template: 'operate-day-template'
        },
        {
          location: 'before',
          template: 'lineSelect'
        },
        {
          location: 'after',
          template: 'reset-template'
        }
      )
    },
    async savePlan () {
      // this.isLoading = true
      const workDays = this.dateArray.filter(item => item.allowEditing !== false)
      const noPlanList = this.planInfoList.filter(item => item.재고여분 === 0 && item.저장여부 === false && item.누적생산수량 > 0)
      let paramArray = []
      noPlanList.forEach(noPlan => {
        let obj = {}
        workDays.forEach(element => {
          const day = parseInt(element.dataField)
          if (noPlan[day] !== undefined && noPlan[day] !== null) {
            if (noPlan[day] !== 0) {
              obj[day] = noPlan[day]
            }
          }
        })
        const param = {
          품번: noPlan.품번,
          차종: noPlan.차종,
          계획연월: noPlan.계획연월,
          생산계획: Object.keys(obj).length <= 0 ? null : JSON.stringify(obj).replace(/"/g, "'")
        }
        paramArray.push(param)
      })
      console.log(paramArray)

      this.$_sp.runInsertOrUpdayeSqlProc('일생산계획', ['품번', '차종', '계획연월'], null, paramArray)
        .then(() => {
          this.$snotify.info('저장되었습니다.')
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
        .finally(() => {
          this.refreshDailyPlan()
          this.isLoading = false
        })
    },
    resetPlan () {
      console.log('test')
      this.$_sp.runUpdateSqlProc('일생산계획', ['계획연월'], null, [{ 계획연월: `${this.selectedDate}-01`, 생산계획: null }])
        .then((data) => {
          this.$snotify.info('초기화 되었습니다.')
          this.refreshDailyPlan()
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang='scss'>
.mrp-wrap {
  margin-top: 10px;
  overflow: hidden;
  display: none;
}
.week-plan {
  tr{
    border-bottom: 1px solid rgb(204, 204, 204);
    height: 27px;
  }
  td{
    border-right: 1px solid rgb(221,221,221);
    padding: 0 6px;
  }
  .row-number-span {
    text-align: right;
  }
  .row-number {
    text-align: right;
    border-left: 0px solid rgb(204, 204, 204);
  }
  .dx-row-minus {
    color: red;
  }

}
.dx-row-toggle {
  background-color: rgb(247, 247, 247);
}
.week-plan:hover {
  background-color: rgb(226, 226, 226);
}
.template-div {
  font-size:1.2rem;margin-left:0px
}
</style>
